import { Alert, AlertTitle } from "@mui/material";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";

export const ModelingAlert: FC = () => {
  const { t } = useResource();

  return (
    <Alert severity="error">
      <AlertTitle>{t(Resources.AnalysisDetail.Modeling.ChangesMade)}</AlertTitle>
      {t(Resources.AnalysisDetail.Modeling.Overdistribution)}
    </Alert>
  );
};
